export function workspaceDomain(location: Pick<Location, "hostname" | "search"> = window.location): string {
  const hostname = location.hostname.trim().toLowerCase().replace(/\.$/, "");
  const local = hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
  if (!local) return hostname;
  const override = new URLSearchParams(location.search).get("workspace")?.trim().toLowerCase().replace(/\.$/, "");
  return override || (import.meta.env.VITE_ANGELFLOW_LOCAL_WORKSPACE_DOMAIN as string | undefined) || "demo.angelflow.local";
}

const publicDomain = () => (import.meta.env.VITE_ANGELFLOW_PUBLIC_DOMAIN as string | undefined)?.trim().toLowerCase()
  || "angelflow.arupa.io";

export function isLocalLocation(location: Pick<Location, "hostname"> = window.location): boolean {
  const hostname = location.hostname.trim().toLowerCase();
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
}

export function isPublicSiteLocation(location: Pick<Location, "hostname" | "search"> = window.location): boolean {
  if (isLocalLocation(location)) return new URLSearchParams(location.search).get("site") === "public";
  return location.hostname.trim().toLowerCase().replace(/\.$/, "") === publicDomain();
}

export function publicSiteUrl(path = "/", location: Pick<Location, "hostname" | "protocol"> = window.location): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (isLocalLocation(location)) {
    const separator = normalizedPath.includes("?") ? "&" : "?";
    return `${normalizedPath}${separator}site=public`;
  }
  return `${location.protocol}//${publicDomain()}${normalizedPath}`;
}

export function workspaceHandoffUrl(
  domain: string,
  code: string,
  location: Pick<Location, "hostname" | "protocol"> = window.location,
): string {
  if (isLocalLocation(location)) {
    return `/auth/handoff?workspace=${encodeURIComponent(domain)}&handoff=${encodeURIComponent(code)}`;
  }
  return `${location.protocol}//${domain}/auth/handoff?handoff=${encodeURIComponent(code)}`;
}
